import { Core } from "@faire/design-tokens";
import styled from "styled-components";

export const VerticalDivider = styled.div`
  height: 20px;
  border-right: 1px solid ${Core.border.muted};
`;
